import { Platform } from 'react-native';
import { tv } from '@/common/theme/tv.config';
import { bgVariants } from '@/common/theme/variants';

export const styles = {
  wrapper: tv({
    base: `${Platform.OS === 'web' ? 'fixed' : 'absolute'} bottom-0 left-0 right-0 top-0 z-[1] justify-center overflow-hidden`,
    variants: {
      position: {
        left: 'items-start',
        center: 'items-center',
        right: 'items-end',
      },
    },
  }),
  container: tv({
    base: 'z-[1] w-full max-w-[90vw] overscroll-contain bg-neutral20',
    variants: {
      size: {
        sm: 'w-[50rem]',
        md: 'w-[80rem]',
        lg: 'w-[102rem]',
      },
      height: {
        auto: 'max-h-[90vh] rounded-xl',
        stretch: 'rounded-none h-full max-h-full',
      },
      backgroundColor: bgVariants,
      overflow: {
        hidden: 'overflow-hidden',
        visible: '',
      },
    },
  }),
  backgroundComponent:
    'absolute bottom-0 left-0 right-0 top-0 overflow-hidden rounded-t-xl',
  content: 'shrink grow',
  scrollContent: 'grow',
};
